import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SelectStatementResult } from "src/app/models/select-statement-result.model";
import { BaseService } from "src/app/services/base.service";
import { QueryFilterParameter } from "src/app/widgets/filters/models/query-filter-parameter.model";


@Injectable({
    providedIn: "root",
})
export class ScenarioAdjustmentService {
    constructor(private baseService: BaseService) { }

    getAllScenarios(): Observable<ScenarioDto[]> {
        const url = `forecast/GetAllScenarios`;
        return this.baseService.get(url);
    }

    getScenarioAdjustmentTargets(): Observable<ScenarioAdjustmentTargetDto[]> {
        const url = `forecast/GetScenarioAdjustmentTargets`;
        return this.baseService.get(url);
    }

    getScenarioAdjustmentTargetFields(targetTable: string): Observable<ListDto[]> {
        const url = `forecast/GetScenarioAdjustmentTargetFields?targetTable=${targetTable}`;
        return this.baseService.get(url);
    }

    getScenarioAdjustmentTableData(targetGroup: string, targetField: string, filters: QueryFilterParameter[]): Observable<SelectStatementResult> {
        const url = `forecast/GetScenarioAdjustmentTableData?targetGroup=${targetGroup}&targetField=${targetField}`;
        return this.baseService.post(url, filters);
    }

    getScenarioAdjustmentNames(): Observable<string[]> {
        const url = `forecast/GetScenarioAdjustmentNames`;
        return this.baseService.get(url);
    }

    getForecastGroups(): Observable<ForecastGroup[]> {
        let url = `forecast/GetScenarioAdjustmentGroupsList`;
        return this.baseService.get(url);
    }

    saveScenarioAdjustmentAndData(adjData: ScenarioAdjustmentTableDto[], adjustmentName: string, targetTable: string, targetField: string): Observable<boolean> {
        const url = `forecast/SaveScenarioAdjustmentAndData?adjustmentName=${adjustmentName}&targetField=${targetField}
            &targetTable=${targetTable}`;
        return this.baseService.post(url, adjData);
    }

    convertSelectStatementDataToAdjTableData(targetGroup: string, targetField: string, selStatData: SelectStatementResult): ScenarioAdjustmentTableDto[] {
        let res: ScenarioAdjustmentTableDto[] = [];
        selStatData.data.forEach(x => {
            res.push({
                selectedGroup: targetGroup,
                period: x.Period,
                forecastIdOrGroup: x[targetGroup],
                original: x[targetField],
                adjustment: 0,
                final: 0
            });
        });

        return res;
    }
}

export class ScenarioAdjustmentResult {
    forecastObjectId: number;
    period: string;
    original: number;
    adjustment: number;
    final: number;
}

export class ScenarioDto {
    scenarioId: number;
    scenarioName: string;
}

export class ScenarioAdjustmentTargetDto {
    targetName: string;
    targetTable: string;
    fieldListId: string;
}

export class ListDto {
    listId: number;
    listElement: string;
}

export class ScenarioAdjustmentTableDto {
    selectedGroup: string;
    forecastIdOrGroup: string;
    period: string;
    original: number;
    adjustment: number;
    final: number;
}

export class ForecastGroup {
    fieldName: string;
    captionName: string;
    orderBy: number;
}